// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color_333 {
  color: #333333;
}

.color_yash {
  color: #707070;
}

.color_green {
  color: #00C596;
}

.color_blue {
  color: #077EE6;
}

.color_red {
  color: #FF6B98;
}

.color_yellow {
  color: #F4D50B;
}

.color_dark_red {
  color: #CB3F3F;
}

.color_dark_blue {
  color: #00388D;
}

.font_14 {
  font-size: 14px;
}

.font_16 {
  font-size: 16px;
}

.font_18 {
  font-size: 18px;
}

.font_12 {
  font-size: 12px;
}

.goto_dashboard .card.Card_border {
  overflow: hidden;
}

.start_practice_button {
  background-color: #F2F9FF;
  border: 1px solid #077EE6;
  color: #077EE6;
  border-radius: 5px;
  opacity: 1;
  font-size: 14px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.Card_border {
  border: 1px solid #DFE8EF;
  border-radius: 10px;
}

.header_bg {
  background-color: #E5F5D4;
  padding: 15px;
  opacity: 1;
}

.hand_icon {
  border: 1px solid #BECBB0;
  padding: 8px;
  border-radius: 5px;
  font-size: 22px;
  color: #71A53B;
  opacity: 1;
}

.box-shadow {
  box-shadow: 0 0px 2px 0px rgba(0, 0, 0, 0.2);
}

.card_bg {
  background-color: #F9F9FA;
}

.button_bg_green {
  background-color: #99E8D5;
}

.button_bg_blue {
  background-color: rgba(54, 161, 245, 0.3);
}

.button_bg_red {
  background-color: #FFE9E9;
}

.table_custom_style thead tr th {
  text-align: center;
  vertical-align: middle;
  padding: 25px 8px;
  background-color: rgba(54, 161, 245, 0.0784313725);
  font-size: 15px;
}

.table_custom_style tbody tr .secondTrCls {
  text-align: center;
  vertical-align: middle;
  padding: 8px;
  background-color: #F9F9FA;
  font-size: 15px;
}
.table_custom_style tbody tr .secondTrCls:first-child {
  text-align: left;
}

.table_custom_style tbody tr td {
  text-align: center;
  vertical-align: middle;
  padding: 8px;
  font-weight: bold;
  font-size: 14px;
}

.table_custom_style tbody tr td:first-child {
  text-align: left !important;
  padding: 8px;
  font-weight: bold;
  font-size: 14px;
}

.icon_WrongCorrected_up::after {
  content: "\\f058";
  position: relative;
  top: -10px;
  font-size: 10px;
  left: -5px;
  color: #00C596;
}

.icon_WrongPending_up::after {
  content: "\\f28b";
  position: relative;
  top: -10px;
  font-size: 10px;
  left: -5px;
  color: #F4A00B;
}

.text-lightgrey {
  color: #d4d4d4 !important;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/learn_practice/goto_dashboard/_chapterStrength.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAGI;EACI,gBAAA;AAAR;;AAIA;EACI,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,aAAA;EACA,UAAA;AADJ;;AAIA;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;AADJ;;AAIA;EACI,4CAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,yCAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kDAAA;EACA,eAAA;AADJ;;AAIA;EACI,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;AADJ;AAGI;EACI,gBAAA;AADR;;AAMA;EACI,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,2BAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ","sourcesContent":[".color_333 {\n    color: #333333;\n}\n\n.color_yash {\n    color: #707070;\n}\n\n.color_green {\n    color: #00C596;\n}\n\n.color_blue {\n    color: #077EE6;\n}\n\n.color_red {\n    color: #FF6B98;\n}\n\n.color_yellow {\n    color: #F4D50B;\n}\n\n.color_dark_red {\n    color: #CB3F3F\n}\n\n.color_dark_blue {\n    color: #00388D;\n}\n\n.font_14 {\n    font-size: 14px;\n}\n\n.font_16 {\n    font-size: 16px;\n}\n\n.font_18 {\n    font-size: 18px;\n}\n\n.font_12 {\n    font-size: 12px;\n}\n\n.goto_dashboard {\n    .card.Card_border {\n        overflow: hidden;\n    }\n}\n\n.start_practice_button {\n    background-color: #F2F9FF;\n    border: 1px solid#077EE6;\n    color: #077EE6;\n    border-radius: 5px;\n    opacity: 1;\n    font-size: 14px;\n    padding-left: 20px;\n    padding-right: 20px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n.Card_border {\n    border: 1px solid #DFE8EF;\n    border-radius: 10px;\n}\n\n.header_bg {\n    background-color: #E5F5D4;\n    padding: 15px;\n    opacity: 1;\n}\n\n.hand_icon {\n    border: 1px solid#BECBB0;\n    padding: 8px;\n    border-radius: 5px;\n    font-size: 22px;\n    color: #71A53B;\n    opacity: 1;\n}\n\n.box-shadow {\n    box-shadow: 0 0px 2px 0px rgba(0, 0, 0, 0.2);\n}\n\n.card_bg {\n    background-color: #F9F9FA;\n}\n\n.button_bg_green {\n    background-color: #99E8D5;\n}\n\n.button_bg_blue {\n    background-color: rgba(54, 161, 245, 0.3);\n}\n\n.button_bg_red {\n    background-color: #FFE9E9;\n}\n\n.table_custom_style thead tr th {\n    text-align: center;\n    vertical-align: middle;\n    padding: 25px 8px;\n    background-color: #36A1F514;\n    font-size: 15px;\n}\n\n.table_custom_style tbody tr .secondTrCls {\n    text-align: center;\n    vertical-align: middle;\n    padding: 8px;\n    background-color: #F9F9FA;\n    font-size: 15px;\n\n    &:first-child {\n        text-align: left;\n    }\n}\n\n\n.table_custom_style tbody tr td {\n    text-align: center;\n    vertical-align: middle;\n    padding: 8px;\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.table_custom_style tbody tr td:first-child {\n    text-align: left !important;\n    padding: 8px;\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.icon_WrongCorrected_up::after {\n    content: \"\";\n    position: relative;\n    top: -10px;\n    font-size: 10px;\n    left: -5px;\n    color: #00C596;\n}\n\n.icon_WrongPending_up::after {\n    content: \"\";\n    position: relative;\n    top: -10px;\n    font-size: 10px;\n    left: -5px;\n    color: #F4A00B;\n}\n\n.text-lightgrey {\n    color: #d4d4d4 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
